import { render, staticRenderFns } from "./StockReductionList_List_Action.vue?vue&type=template&id=b5b58bb2&"
import script from "./StockReductionList_List_Action.vue?vue&type=script&lang=js&"
export * from "./StockReductionList_List_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports